// @ts-nocheck
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GoogleMapsDirectionLink from "@insite/content-library/Components/GoogleMapsDirectionLink";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
// import constants from "@store/constants"; // Foundation
import GlobeFill from "@store/Library/Components/Toolkit/Icons/Globe/GlobeFill";
import Navigation2Fill from "@store/Library/Components/Toolkit/Icons/Navigation2/Navigation2Fill";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC, useContext } from "react";

/* Foundation Custom Code - Start */
import constants from "@store/constants";
import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { FieldDefinitionBuilderOptions } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
/* Foundation Custom Code - End */

export interface DealerDetailsHeaderProps extends WidgetProps {
    fields: FieldDefinitionBuilderOptions<"titleStyle" | "titleType">; // Foundation
}

export interface DealerDetailsHeaderStyles {
    googleMapsDirectionLink?: LinkPresentationProps;
    visitWebsiteLink?: LinkPresentationProps;
}

export const dealerDetailsHeaderStyles: DealerDetailsHeaderStyles = {
    googleMapsDirectionLink: linkGetActionLinkProps(Navigation2Fill),
    visitWebsiteLink: linkGetActionLinkProps(GlobeFill),
};

const styles = dealerDetailsHeaderStyles;

const DealerDetailsHeader: FC<DealerDetailsHeaderProps> = ({ fields /* Foundation */ }) => {
    const { value: dealer } = useContext(DealerStateContext);
    const linkBack = usePageLinkByPageType(constants.pageType.locationFinder);

    if (!dealer) {
        return null;
    }

    return (
        <OrderHeader title={dealer.name} linkBack={linkBack}>
            {dealer.webSiteUrl && (
                <Link href={dealer.webSiteUrl} target="_blank" {...styles.visitWebsiteLink}>
                    {translate("Visit Website")}
                </Link>
            )}
            <GoogleMapsDirectionLink {...styles.googleMapsDirectionLink} {...dealer} />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule<FoundationFieldDefinition /* Foundation */> = {
    component: DealerDetailsHeader,
    definition: {
        group: "Dealer Details",
        displayName: "Header",
        allowedContexts: ["DealerDetailsPage"],
        /* Foundation Custom Code - Start */
        fieldDefinitions: fieldDefinitionBuilder([], {
            typographyOptions: {
                titleType: true,
                titleStyle: true,
            },
        }),
        /* Foundation Custom Code - End */
    },
};

export default widgetModule;
